import React from 'react';
import { Input} from "reactstrap";
import { FieldProps } from 'formik'

import FormikFieldCustomProps from "../field/formikfieldcustomprops";

const AnswerInput: React.FC<FormikFieldCustomProps & FieldProps & {alphabet?: any; correct?:string; onFocus: (arg0:any) => void; onBlur: () => void; index:number}> = ({
  field: { ...fields },
  form: { touched, errors, ...rest },
  ...props
}) => {
  return (
    <div className="answer-input-container">
      <div className="alpha-container">
        {props.alphabet && <span className="alpha">{props.alphabet}</span>}
        {props.correct === 'true' && <img className="correct-tick" src="/icons/correct.svg" alt="" />}
      </div>
      <Input
        {...props}
        {...fields}
        onChange={e => {
          props.onFocus(e)
          fields.onChange(e)
        }}
        autoFocus={props.index !==0 }
        autoComplete="off"
        onBlur={props.onBlur}
        invalid={Boolean(touched[fields.name] && errors[fields.name])} />
    </div>
  )
}

export default AnswerInput;
